var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 19H5M15 19H15.803C16.921 19 17.48 19 17.907 18.782C18.284 18.59 18.59 18.284 18.782 17.908C19 17.481 19 16.921 19 15.803V7.22C19 6.77 19 6.545 18.952 6.331C18.9094 6.14007 18.839 5.95643 18.743 5.786C18.637 5.596 18.487 5.431 18.193 5.104L15.438 2.042C15.097 1.664 14.924 1.472 14.717 1.334C14.5303 1.21012 14.3241 1.11851 14.107 1.063C13.863 1 13.6 1 13.075 1H4.2C3.08 1 2.52 1 2.092 1.218C1.71565 1.40969 1.40969 1.71565 1.218 2.092C1 2.52 1 3.08 1 4.2V15.8C1 16.92 1 17.48 1.218 17.907C1.41 18.284 1.715 18.59 2.092 18.782C2.519 19 3.079 19 4.197 19H5M15 19V15.197C15 14.079 15 13.519 14.782 13.092C14.5899 12.7156 14.2836 12.4096 13.907 12.218C13.48 12 12.92 12 11.8 12H8.2C7.08 12 6.52 12 6.092 12.218C5.71565 12.4097 5.40969 12.7157 5.218 13.092C5 13.52 5 14.08 5 15.2V19M13 5H7",
    stroke: "#273896",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.bab7c0b28aa1785a241c6abe995781bb.svg";
export { ForwardRef as ReactComponent };